export const SOMETHING_ELSE = "SOMETHING_ELSE"
export const UNSURE = "UNSURE"
export const SPECIALIST = "SPECIALIST"
export const OTHER = "OTHER"



// WEBPACK FOOTER //
// ./assets/feedback/constants.js